type CompanyAvatarSource = {
  avatar?: string | null;
  logoUrl?: string | null;
  avatarUrl?: string | null;
  imageUrl?: string | null;
  logo?: string | null;
  businessName?: string | null;
};
const MOCK_COMPANY_AVATAR_BY_NAME: Record<string, string> = {
  "Blue Axe": "https://flownect-media-dev.s3.us-west-1.amazonaws.com/images/Company-avatar/cube.png",
  "Shelley Hurst": "https://flownect-media-dev.s3.us-west-1.amazonaws.com/images/Company-avatar/eye.png",
  "Cooper Marquez": "https://flownect-media-dev.s3.us-west-1.amazonaws.com/images/Company-avatar/green.png",
  "Ciara Burgess": "https://flownect-media-dev.s3.us-west-1.amazonaws.com/images/Company-avatar/sese.png",
};
// Busca la mejor URL disponible para mostrar como avatar/logo de compañía.
// Por ahora soporta varios nombres posibles porque el backend todavía no está cerrado.
export const getCompanyAvatarSrc = (company?: CompanyAvatarSource | null): string | undefined => {
  const src = company?.avatar || company?.logoUrl || company?.avatarUrl || company?.imageUrl || company?.logo || "";

  if (src.trim()) return src.trim();

  const businessName = company?.businessName?.trim();
  if (businessName && MOCK_COMPANY_AVATAR_BY_NAME[businessName]) {
    return MOCK_COMPANY_AVATAR_BY_NAME[businessName];
  }

  return undefined;
};
